import { NgModule } from '@angular/core';
import { RouteReuseStrategy,RouterModule, Routes, Router, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { OopsComponent } from './oops/oops.component';
import { CheckoutCommon } from './pages/_brand-pages-base/base-controllers/checkout/checkout-common';
import { CheckoutCommonTC } from './pages/checkout-pages/checkout-commonTC';
import { WhatIsThisPage } from '../pages/what-is-this/what-is-this';
import { SafeOrderPage } from '../pages/safe-order/safe-order';
import { DestinationComponent } from './destination/destination.component';
import { UpsellDynamic } from './upsell/upsell-dynamic';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { GdprComponent } from './gdpr/gdpr.component';
import { CcpaComponent } from './ccpa/ccpa.component';
import { TermsComponent } from './terms/terms.component';
import { PageConfigDataResolver } from './resolve/page-config-data-resolve';
import { UpsellrdComponent } from 'src/upsellrd/upsellrd.component';

const US_GENERIC_MODULE_IMPORT = import('./upsells-downsells/upsells/us-generic/us-generic.module').then(m => m.USGenericModule);
const UPSELL_RD_MODULE_IMPORT = import('../upsellrd/upsellrd.module').then(m => m.UpsellrdModule);
const ORDER_SUCCESS_MODULE_IMPORT = import('./order-success/order-success.module').then(m => m.OrderSuccessModule);

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: OopsComponent },
  { path: 'PrivacyPolicy', component: PrivacyPolicyComponent },
  { path: 'gdpr', component: GdprComponent },
  { path: 'ccpa', component: CcpaComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'fst/:generidUrl', component: DestinationComponent },
  { path: 'Hartfelt_Receipt_AP', data: { animation: 'enterLeavePage' }, loadChildren: () => ORDER_SUCCESS_MODULE_IMPORT },
  { path: 'upDownDyn', component: UpsellDynamic, data: { animation: 'enterLeavePage' } },
  { path: 'what-is-this', component: WhatIsThisPage },  // TODO make a module to lazy load this page
  { path: 'safe-order', component: SafeOrderPage }, // TODO make a module to lazy load this page
  { path: 'OrderSuccess', loadChildren: () => ORDER_SUCCESS_MODULE_IMPORT },
  { path: 'what-is-this', component: WhatIsThisPage },  // TODO make a module to lazy load this page
  { path: 'safe-order', component: SafeOrderPage }, // TODO make a module to lazy load this page
 // { path: 'upsellrd', loadChildren: () => import('../upsellrd/upsellrd.module').then(m => m.UpsellrdModule) },
  { path: 'upsellrd', component: UpsellrdComponent},

  { path: 'Hartfelt_SecureCart', component: CheckoutCommonTC, data: {  currency: 'USD',   officialCurrency: 'USD', currencySymbol: '$',  checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC',enablePaypalButton:true } }, //DEV-47271

  { path: 'Hartfelt_SecureCartOld', component: CheckoutCommon, data: {  currency: 'USD',   officialCurrency: 'USD', currencySymbol: '$',  checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC' } }, //DEV-47271

  { path: 'Hartfelt_SecureCart_260203', component: CheckoutCommonTC, data: { enableCyberSource: true, braintreeSubscriptionSupported: true, braintreeEnabled: true, braintreeDropInEnabled: false, useNewBraintreeStyles: true, euSpecified: false, currency: 'USD', braintreeCurrencyConversion: 1.00, braintreeDefaultCountry: 'United States', officialCurrency: 'USD', currencySymbol: '$', braintreeCountryLabel: true, checkoutFeature: 'showProductBoxVariant1,showFeatures,isCheckoutCommonTC' } },

  // NEW UPSELL/DOWNSELLS - OCTOBER 2024 
  { path: 'CTUS_3-Unit-AngusBeef_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, vidalyticsEmbedId: 'VCUoMv11XFCeS_ll', pageConfigPath: '../assets/page-configurations/upsells/CTUS_3-Unit-AngusBeef_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'CTUS_6-Unit-AngusBeef_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, vidalyticsEmbedId: '0gw2gMC4l3zQW_uZ', pageConfigPath: '../assets/page-configurations/upsells/CTUS_3-Unit-AngusBeef_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'US_3-Unit-BeefLiverTeats-AngusBeef_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BeefLiverTeats-AngusBeef_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'US_6-Unit-BeefLiverTeats-AngusBeef_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BeefLiverTeats-AngusBeef_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'US_3-Unit-JointSupplement-AngusBeef_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-JointSupplement-AngusBeef_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'US_6-Unit-JointSupplement-AngusBeef_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-JointSupplement-AngusBeef_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'US_3-Unit-BeefLiverTeats_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BeefLiverTeats_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'US_6-Unit-BeefLiverTeats_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BeefLiverTeats_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'US_3-Unit-AngusBeef-BeefLiverTeats_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-AngusBeef-BeefLiverTeats_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'US_6-Unit-AngusBeef-BeefLiverTeats_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-AngusBeef-BeefLiverTeats_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'US_3-Unit-JointSupplement-BeefLiverTeats_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-JointSupplement-BeefLiverTeats_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'US_6-Unit-JointSupplement-BeefLiverTeats_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-JointSupplement-BeefLiverTeats_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },


  //////////////////////////////////////////////////////////// DOWNSELLS ///////////////////////////////////////////////////////////////////
  { path: 'DS_1-Unit-AngusBeef_AP', data: { animation: 'enterLeavePage', productQuantity: 1, productQuantityNextUp: 3, productUnitType: "bag", pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-AngusBeef_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'DS_3-Unit-AngusBeef_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, productUnitType: "bags", pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-AngusBeef_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  
  { path: 'DS_1-Unit-BeefLiverTeats_AP', data: { animation: 'enterLeavePage', productQuantity: 1, productQuantityNextUp: 3, productUnitType: "bag", pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-BeefLiverTeats_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'DS_3-Unit-BeefLiverTeats_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, productUnitType: "bags", pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-BeefLiverTeats_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'DS_1-Unit-JointSupplement_AP', data: { animation: 'enterLeavePage', productQuantity: 1, productQuantityNextUp: 3, productUnitType: "jar", pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-JointSupplement_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'DS_3-Unit-JointSupplement_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, productUnitType: "jars", pageConfigPath: '../assets/page-configurations/downsells/DS_1-Unit-JointSupplement_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'US_3-Unit-MobilityRelief_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MobilityRelief_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'US_6-Unit-MobilityRelief_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-MobilityRelief_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'US_3-Unit-AngusBeef-MobilityRelief_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, vidalyticsEmbedId: 'VCUoMv11XFCeS_ll', pageConfigPath: '../assets/page-configurations/upsells/CTUS_3-Unit-AngusBeef-MobilityRenew_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'US_6-Unit-AngusBeef-MobilityRelief_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, vidalyticsEmbedId: 'VCUoMv11XFCeS_ll', pageConfigPath: '../assets/page-configurations/upsells/CTUS_3-Unit-AngusBeef-MobilityRenew_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

  { path: 'US_3-Unit-BeefLiverTeats-MobilityRelief_AP', data: { animation: 'enterLeavePage', productQuantity: 3, productQuantityNextUp: 6, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BeefLiverTeats-MobilityRelief_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },
  { path: 'US_6-Unit-BeefLiverTeats-MobilityRelief_AP', data: { animation: 'enterLeavePage', productQuantity: 6, productQuantityNextUp: 12, pageConfigPath: '../assets/page-configurations/upsells/US_3-Unit-BeefLiverTeats-MobilityRelief_AP.json' }, loadChildren: () => US_GENERIC_MODULE_IMPORT, resolve: { pageConfigData: PageConfigDataResolver } },

];

class CustomReuseStrategy extends RouteReuseStrategy {
  /**
   * Determines if a route should be detached and stored for potential reuse.
   * Returns false as we don't store routes.
   */
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Stores a detached route (not used in this implementation).
   */
  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
    // No-op: routes are not stored
  }

  /**
   * Determines if a stored route should be attached.
   * Returns false as we don't store routes.
   */
  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  /**
   * Retrieves a stored route (not used in this implementation).
   */
  retrieve(_route: ActivatedRouteSnapshot): ActivatedRouteSnapshot | null {
    return null;
  }

  /**
   * Determines whether to reuse a route when navigating.
   * On iOS devices, routes are never reused to maintain compatibility
   *
   * @param future The route being navigated to
   * @param curr The current route
   * @returns true if the route should be reused, false otherwise
   */
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    // Check if iOS with safe fallback for SSR/testing environments
    const isIOS = this.detectIOSDevice();

    if (isIOS) {
      return false; // Never reuse on iOS
    }

    // Default Angular behavior: reuse if route configs are identical
    return future.routeConfig === curr.routeConfig;
  }

  /**
   * Detects if the current device is an iOS device.
   * Returns false if navigator is unavailable (SSR/testing).
   */
  private detectIOSDevice(): boolean {
    if (typeof navigator === "undefined" || !navigator.userAgent) {
      return false; // Safe fallback for SSR
    }

    // Check for iPhone, iPad, or iPod in user agent
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }]
})
export class AppRoutingModule {
  constructor(public router: Router) {
    console.log("[GH] AppRoutingModule constructor " + document.location.origin + '/assets/html/a18tests.html');
    let content = {};
    let logic = (content: any) => {
      if (Object.keys(content).length === 0) {
        console.log("[GH] Error getting upsell dynamic content");
        this.routeHandlerFinally();
        return;
      } else {
        console.log("[GH] Got upsell dynamic content", content);
      }
      for (let prop in content) {
        if (prop == "fileListStream") {
          for (const key in (content as any)[prop]) {
            if ((content as any)[prop].hasOwnProperty(key)) {
              /*  console.log(
                 `[GH] push this key? ${key}`,
                 (content as any)[prop][key]
               ); */
              //console.log('this.router.config', ...this.router.config);

              let alreayAdded = false;
              for (let i = 0; i < this.router.config.length; i++) {
                if (this.router.config[i].path == (content as any)[prop][key].url) {
                  //console.log('route already added ' + (content as any)[prop][key].url);
                  alreayAdded = true;
                  break;
                }
              }
              if (alreayAdded) {
                continue;
              }

              if (typeof (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent == 'object') {
                let isvalid = false;
                for (let i = 0; i < (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent.length; i++) {
                  //console.log('checking '+(content as any)[prop][key].url, (window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent[i])
                  if ((window as any)['upsellDynamicCMSControl'].dynamicPageNamesWithContent[i] == 'upDownDyn-' + (content as any)[prop][key].url + '.json') {
                    isvalid = true;
                    break;
                  }
                }
                if (!isvalid) {
                  continue;
                }
                this.router.config.push({
                  path: (content as any)[prop][key].url,
                  component: UpsellDynamic,
                  data: { animation: "enterLeavePage" },
                });
              } else {
                console.log('upsellDynamicCMSControl.dynamicPageNamesWithContent is not an array');
              }
            }
          }
        }
      }
      this.routeHandlerFinally();
    }
    if ((window as any)['upsellDynamicContent']) {
      logic((window as any)['upsellDynamicContent']);
      return;
    }
    let xhr = new XMLHttpRequest();
    xhr.open("GET", "/assets/content/store_dynamic_upsell_control.json", false);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = () => {
      if (typeof xhr.response == "string") content = JSON.parse(xhr.response);
      else if (typeof xhr.response == "object") content = xhr.response;
      logic(content);
    };
    xhr.onerror = (error) => {
      console.log(`XHR Error: ${error}`);
      this.routeHandlerFinally();
    };

    xhr.send();
  }

  routeHandlerFinally() {
    // Wildcard route TODO add a not found handler
    this.router.config.push({
      path: "**",
      component: OopsComponent,
      data: { animation: "enterLeavePage" },
    });
  }
}
